// Types
import type { TProgressBarLabelPosition, TProgressBarProps } from './ProgressBar.type';

export const PROGRESS_BAR_LABEL_POSITIONS: TProgressBarLabelPosition[] = ['bottom-left',
	'bottom-right',
	'float-bottom',
	'float-top',
	'left',
	'right'];
export const PROGRESS_BAR_LABEL_POSITION: { [key in TProgressBarLabelPosition]: key } = {
	'bottom-left': 'bottom-left',
	'bottom-right': 'bottom-right',
	'float-bottom': 'float-bottom',
	'float-top': 'float-top',
	'left': 'left',
	'right': 'right'
};

export const PROGRESS_BAR_DEFAULT_PROPS: TProgressBarProps = {
	value: 0,
	labelPosition: PROGRESS_BAR_LABEL_POSITION.right
};
